import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MatchService } from '../match.service';
import { Subscription, interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-test-fancy',
  templateUrl: './test-fancy.component.html',
  styleUrls: ['./test-fancy.component.css']
})
export class TestFancyComponent implements OnInit, OnDestroy {
  isLoading = false;
  id: any;
  afdata = [];
  fancyTimeout;
  private fancySub: Subscription;
  private destroyed = new Subject();
  constructor(private route: ActivatedRoute, private matchService: MatchService) { }

  ngOnInit() {
    this.isLoading = true;
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has('id')) {
        this.id = paramMap.get('id');
        this.matchService.getDiamondFancy(this.id, 'diamond');
        this.fancyScheduler();
        this.fancySub = this.matchService.getUpdateDiamondFancyListner().subscribe((resp) => {
          this.isLoading = false;
          //console.log(resp.diamondFancy['result'].data);
          if (resp.diamondFancy['result'].data == null) {
            this.afdata = [];
            this.destroyed.next();
            this.fancyTimeout = setTimeout(() => {
              this.fancyScheduler();
            }, 3000);
          }
          else {
            let data = JSON.parse(resp.diamondFancy['result'].data);
            if (data.data.t3 != null) {
              let datas = data.data.t3;
              this.afdata = datas.filter(resp => {
                return resp.ballsess != '3' && resp.ballsess != '2';
              }).sort((a, b) => (a.srno > b.srno) ? 1 : -1);
              //console.log(this.afdata);
            }
          }
        });
      }
    });
  }

  fancyScheduler() {
    interval(500).pipe(takeUntil(this.destroyed)).subscribe(() => {
      this.matchService.getDiamondFancy(this.id, 'diamond');
    });
  }

  ngOnDestroy() {
    clearTimeout(this.fancyTimeout);
    this.destroyed.next();
  }
}